import React from "react";
import WorkView from "./WorkView";
import { work } from "../constants";

const Work: React.FC = () => {
  return (
    <section className="work" id="work">
      <div className="container">
        <h2 className="text-center text-uppercase text-secondary mb-0">work</h2>
        <hr className="star-dark mb-5" />
        <div className="row">
          {work.map((workData: any, id: number) => (
            <WorkView data={workData} key={id} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Work;
